import React, { useState, useEffect } from 'react'

import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

import useBreakpoint from '../../../Utils/useBreakpoint'

function Layout({
  activeBreadcrumb,
  children,
  hideUploadButton = false,
  showNextStepsOverlay = null,
  newRoyaltyUi = false,
  withBoostingPoints = false,
  boostCredits: initialBoostCredits = 0,
}) {
  const [boostCredits, setBoostCredits] = useState(initialBoostCredits)
  const breakpoint = useBreakpoint()
  const isMobile = breakpoint === 'xs'

  useEffect(() => {
    const updateBoostCredits = (value) => {
      setBoostCredits(value)
    }

    App.events.subscribe('update-boost-credits', updateBoostCredits)

    return () => {
      App.events.remove('update-boost-credits', updateBoostCredits)
    }
  }, [])

  return (
    <div className={`container-fixed${newRoyaltyUi ? ' cgt-mt-20' : ''}`}>
      {showNextStepsOverlay && (
        <div className="u-float-right u-ml10">
          <button className="btn btn-outline-default btn-white next-step-btn" onClick={showNextStepsOverlay}>
            <Icon type={['far', 'link']} notSpaced />
          </button>
        </div>
      )}

      {!hideUploadButton && (
        <div className="u-float-right">
          <a href="/profile/upload/model" className="btn btn-primary">
            Upload
          </a>
        </div>
      )}

      {withBoostingPoints && (
        <div className="u-float-right u-mr10">
          <div className="btn btn-outline-default btn-white next-step-btn profile-layout__boost-credits">
            <div>
              <span className="profile-layout__boost-credits-text">You have: </span>
              <span className="profile-layout__boost-credits-value">{boostCredits} boost credits</span>
            </div>
            <Tooltip
              id="boost-credits-info"
              content={
                'Boost Credits let you promote your models to increase visibility on the marketplace. ' +
                "Click the 'Promote' button below to spend your credits and launch a campaign.\n\n" +
                "If you'd like to purchase more credits, please contact our support team at " +
                '<a href="mailto:support@cgtrader.com">support@cgtrader.com</a> or ' +
                '<a href="https://help.cgtrader.com/hc/en-us/requests/new" ' +
                'target="_blank" rel="noopener noreferrer">request form</a> ' +
                'for a personalized pricing plan.'
              }
              place={isMobile ? 'bottom' : 'left'}
              tooltipClassName="profile-layout__boost-credits-tooltip"
              html
              clickable
            >
              <Icon type={['fas', 'info-circle']} className="profile-layout__info-icon" />
            </Tooltip>
          </div>
        </div>
      )}

      {!newRoyaltyUi && (
        <ul className="breadcrumb breadcrumb-new">
          <li className="breadcrumb__item">
            <a href="/">CGTrader</a>
          </li>
          <li className="breadcrumb__item">
            <a href="/profile">Profile</a>
          </li>
          <li className="breadcrumb__item is-active">{activeBreadcrumb}</li>
        </ul>
      )}

      {children}
    </div>
  )
}

Layout.propTypes = {
  activeBreadcrumb: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hideUploadButton: PropTypes.bool,
  showNextStepsOverlay: PropTypes.func,
  withBoostingPoints: PropTypes.bool,
  boostCredits: PropTypes.number,
  newRoyaltyUi: PropTypes.bool,
}

export default Layout
